import React from 'react';

import CatalogInput from '../../../components/CatalogInput';

function CatalogRadioFilter({filter, onChange, catalog, validations}) {
  return (
    <CatalogInput
      placeholder="Choose a catalog item..."
      catalog={catalog}
      value={filter.values[0]}
      onChange={value => onChange({...filter, values: [value]})}
      invalid={validations.length > 0}
      validationText={validations[0]}
    />
  );
}

CatalogRadioFilter.validate = filter => {
  if (!filter.values.length > 0) {
    return ['Please choose an option'];
  }

  return [];
};

CatalogRadioFilter.operators = [
  'CONTAIN'
];

export default CatalogRadioFilter;
